module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pubInfo font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "id": "p4"
    }
  }, [_c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-AvantGarde-Book-4_1-8"
  }, [_vm._v("Text copyright © 2009 by ")]), _c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-8_5"
  }, [_vm._v("Bob Sloan")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-AvantGarde-Book-4_1-8"
  }, [_vm._v("Photographs copyright © 2009 by ")]), _c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-8_5"
  }, [_vm._v("Antonis Achilleos ")]), _c('span', {
    staticClass: "font-AvantGarde-Book-4_1-8"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AvantGarde-Book-4_1-8"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AvantGarde-Book-4_1-8"
  }, [_vm._v("ISBN 978-1-4521-3162-7"), _c('br'), _vm._v("Library of Congress Cataloging-in-Publication Data available under ISBN 978-0-8118-6698-9.")]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AvantGarde-Book-4_1-8"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-AvantGarde-Book-4_1-8"
  }, [_vm._v("Prop styling by ")]), _c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-8_5"
  }, [_vm._v("Sara Slavin")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-AvantGarde-Book-4_1-8"
  }, [_vm._v("Food styling by ")]), _c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-8_5"
  }, [_vm._v("Randy Mon")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-AvantGarde-Book-4_1-8"
  }, [_vm._v("Opener Illustrations by ")]), _c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-8_5"
  }, [_vm._v("Laura Bagnato")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-GoudyHeavyfaceBT-Regular-3_1-8_5"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-AvantGarde-Book-4_1-8"
  }, [_vm._v("Designed by ")]), _c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-8_5"
  }, [_vm._v("MacFadden & Thorpe")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-GoudyHeavyfaceBT-Regular-3_1-8_5"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AvantGarde-Book-4_1-8"
  }, [_vm._v("Chronicle Books LLC")]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AvantGarde-Book-4_1-8"
  }, [_vm._v("680 Second Street")]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AvantGarde-Book-4_1-8"
  }, [_vm._v("San Francisco, California 94107")]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AvantGarde-Book-4_1-8"
  }, [_c('br')])]), _c('p', {
    staticClass: "running_first color-3C1C00 font-AvantGarde-Book-4_1-8"
  }, [_c('a', {
    attrs: {
      "id": "p4"
    }
  }), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "url"
  }, [_vm._v("www.chroniclebooks.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bd86456","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/003copyright.vue
// module id = 63
// module chunks = 0